import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Grid} from 'views/components';
import {CardTable} from 'views/module';

import Card from './Card';

const List = (props) => {
  const {data, isLoading, loadMore, hasMore, highlightedCaregiverId, selectedCaregivers, setSelectedCaregivers} = props;

  return (
    <Grid container>
      <CardTable
        data={data}
        card={(props) => {
          const {item} = props;
          return (
            <Card
              {...props}
              selected={selectedCaregivers.includes(item.caregiverRn)}
              setSelectedCaregivers={setSelectedCaregivers}
            />
          );
        }}
        isLoading={isLoading}
        loadMore={loadMore}
        hasMore={hasMore}
        highlightedId={highlightedCaregiverId}
        getItemId={(item) => item.caregiverRn}
        selected={selectedCaregivers}
      />
    </Grid>
  );
};

List.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  hasMore: PropTypes.bool,
  visibleCaregiverIds: PropTypes.array,
  highlightedCaregiverId: PropTypes.string,
  selectedCaregivers: PropTypes.array,
  onToggleSelect: PropTypes.func,
  setSelectedCaregivers: PropTypes.func,
  item: PropTypes.object,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(List));
